import React, { useState } from 'react';
import { X, Loader2, Droplet, Calendar, Gauge, AlignLeft } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import { Modal } from '../common';
import toast from 'react-hot-toast';

const todayStr = () => new Date().toISOString().slice(0, 10);

const CambioAceiteModal = ({ isOpen, onClose, onSuccess, vehiculo }) => {
  const [fecha, setFecha] = useState(todayStr());
  const [kilometraje, setKilometraje] = useState('');
  const [observacion, setObservacion] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const resetForm = () => {
    setFecha(todayStr());
    setKilometraje('');
    setObservacion('');
    setError(null);
  };

  const handleOpenPrefill = () => {
    if (vehiculo && kilometraje === '') {
      setKilometraje(String(Math.round(Number(vehiculo.kilometraje_actual || 0))));
    }
  };

  React.useEffect(() => {
    if (isOpen) handleOpenPrefill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fecha) {
      setError('La fecha es obligatoria');
      return;
    }
    if (kilometraje === '' || Number(kilometraje) < 0) {
      setError('Ingresa el kilometraje exacto del cambio');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await axiosInstance.post(`/api/equipos-moviles/vehiculos/${vehiculo.id}/cambio-aceite`, {
        fecha,
        kilometraje: Number(kilometraje),
        observacion: observacion.trim(),
      });
      toast.success('Cambio de aceite registrado');
      resetForm();
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error registrando cambio de aceite:', err);
      setError(err.response?.data?.error || 'Error al registrar el cambio de aceite');
    } finally {
      setLoading(false);
    }
  };

  if (!vehiculo) return null;

  const inputClass = "w-full px-3.5 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition-all";
  const labelClass = "flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-gray-500 mb-1.5";

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md">
      <Modal.Header onClose={handleClose}>
        <div className="flex items-center gap-3">
          <div className="p-2 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl text-white shadow-lg shadow-amber-200">
            <Droplet size={20} />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Se Realizó Cambio de Aceite</h3>
            <p className="text-xs text-gray-500 font-normal">{vehiculo.nombre}</p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit} id="cambio-aceite-form" className="space-y-4">
          <div>
            <label className={labelClass}><Calendar size={13} /> Fecha del cambio</label>
            <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} className={inputClass} />
          </div>

          <div>
            <label className={labelClass}><Gauge size={13} /> Kilometraje exacto</label>
            <input
              type="number"
              min="0"
              step="0.1"
              value={kilometraje}
              onChange={(e) => setKilometraje(e.target.value)}
              className={inputClass}
            />
            <p className="text-xs text-gray-400 mt-1.5">Este valor se toma como base para el próximo cambio de aceite.</p>
          </div>

          <div>
            <label className={labelClass}><AlignLeft size={13} /> Observación</label>
            <textarea
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="¿Se le hizo algo más al vehículo aparte del cambio de aceite?"
              rows={3}
              className={`${inputClass} resize-none`}
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm animate-fadeIn">
              <X size={16} className="flex-shrink-0" />
              <span>{error}</span>
            </div>
          )}
        </form>
      </Modal.Body>

      <Modal.Footer>
        <div className="flex items-center justify-end w-full gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="px-5 py-2.5 text-gray-600 font-medium hover:bg-gray-100 rounded-xl transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            form="cambio-aceite-form"
            disabled={loading}
            className="px-6 py-2.5 font-semibold rounded-xl transition-all flex items-center gap-2 shadow-sm bg-gradient-to-r from-amber-500 to-orange-600 text-white hover:from-amber-600 hover:to-orange-700 shadow-amber-200 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? 'Guardando...' : 'Confirmar Cambio'}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CambioAceiteModal;
